export const NAME = 'contest';

export const TABS = {
  ENTRY: 'entry',
  PRIZE: 'prize',
  DESCRIPTION: 'description',
  WINNERS: 'winners',
};
